import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { MainRouteKeys } from 'routes/enums';
import { Icon } from '../../../../components';

const transferWrapper = (Component: FC<any>) => (props: any) => {
  return (
    <div className='transfer-wrapper'>
      <div className='TabLinks'>
        <NavLink to={MainRouteKeys.TransferList}>
          <Icon.User />
          <p className='d-none d-md-block'>Danh sách</p>
        </NavLink>

        <NavLink
          to={MainRouteKeys.TransferToUser}
          // isActive={() => props?.location?.pathname === '/transfer/to-user'}
        >
          <Icon.KYC />
          <p className='d-none d-md-block'>Chuyển điểm</p>
        </NavLink>
      </div>

      <Component {...props} />
    </div>
  );
};

export default transferWrapper;
